

exports.__esModule = true;
exports.$SidebarWalletRoute = undefined;

var _squid = require('squid');

var _route = require('xo-wallet-components/src/confirm-upop/route');

var _route2 = _interopRequireDefault(_route);

var _route3 = require('xo-credit-components/src/apply-ppc/route');

var _route4 = _interopRequireDefault(_route3);

require('./directive');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $SidebarWalletRoute = exports.$SidebarWalletRoute = _squid.$ComponentRoute.extend('$SidebarWalletRoute', {

    path: 'wallet',
    directive: 'xo-wallet',
    titleContent: 'asideHeader.wallet',
    trackingData: {
        fptiState: 'funding_option_selection',
        templateName: 'fundingInstruments.dust',
        pageGoal: 'Change Instruments',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-wallet-fundingsources',
                'pagename2': '%::fullpage-wallet-fundingsources:member:hermes:',
                'version': 'member:%:'
            }
            // More page qualifiers come here...
        }
    },
    params: {
        padToggleFeature: null
    },
    children: [{
        route: _route2['default'],
        attributes: {
            token: 'token',
            phone: 'phone',
            cardmodel: 'cardModel'
        }
    }, {
        route: _route4['default'],
        props: function props() {
            return {
                token: this.token
            };
        }
    }]
});

angular.value("$SidebarWalletRoute", $SidebarWalletRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-wallet/route.js
// module id = ./pages/xo-wallet/route.js
// module chunks = 1